import { axiosClient } from './axios_client';

export const firmware_api = {
  list: (params = {}) =>
    axiosClient.get('/api/firmware', {
      params: { ...params, _t: Date.now() },
      headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
    }),
  getLatest: (target, params) =>
    axiosClient.get(`/api/firmware/latest/${target}`, { params }),
  upload: (formData) =>
    axiosClient.post('/api/firmware', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  update: (id, data) => axiosClient.put(`/api/firmware/${id}`, data),
  remove: (id) => axiosClient.delete(`/api/firmware/${id}`),
  downloadUrl: (id) => `/api/firmware/${id}/download`,
};
